import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { Class } from 'ts/types/Class'
import { formatter } from 'utils'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import ClassAddPage from './ClassAddPage'

const ClassPage = () =>{
  const Url = GetUrls();
  const columns: Column<Class>[] = [
    {
      Header: 'ID',
      accessor: 'classId'
    },
    {
      Header: 'Active',
      accessor: 'flActive',
      Cell: ({ value }) => <BooleanCell value={value} />
    },
    {
      Header: 'Class Name',
      accessor: 'name'
    },
    {
      Header: 'Last Modified',
      accessor: 'lastModified',
      Cell: ({ value }) => formatter.dateTime(value)
    }
  ]
  return(
  <CardTable
    columns={columns}
    dataKey={Url.getClass.toString()}
    url={Url.getClass.toString()}
    modalChild={<ClassAddPage />}
    // dataKey={`${Url.getClass.toString()}?departmentId=61`}
    // url={`${Url.getClass.toString()}?departmentId=61`}
    // listName={"classList"}
  />
)
}
  

export default ClassPage
